(() => {
  function closestGiftRoot(el) {
    return el?.closest?.(".exp-gift") || null;
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) el.setAttribute("hidden", "");
    else el.removeAttribute("hidden");
  }

  function brandCount(root) {
    return parseInt(root?.dataset?.brandCount || "0", 10);
  }

  function getBrandOptionsCSV(root) {
    return (root?.dataset?.brandOptions || "").trim();
  }

  function getMethod(root) {
    const checked =
      root.querySelector('input[type="radio"][name="properties[Redemption Method]"]:checked')
        ?.value || "";
    if (checked) return checked;

    return (
      root.querySelector('input[name="properties[Redemption Method]"]')?.value ||
      "Sender's Choice"
    );
  }

  function getForm(root) {
    const id = root.dataset.productFormId;
    if (id) {
      const byId = document.getElementById(id);
      if (byId && byId.tagName.toLowerCase() === "form") return byId;
    }
    return root.closest("form") || null;
  }

  function getSubmitButton(form) {
    if (!form) return null;
    return form.querySelector('[type="submit"]');
  }

  function syncBrandHiddenAndActive(root) {
    const checked = root.querySelector('input[type="radio"][name="properties[Brand]"]:checked');
    const brandHidden = root.querySelector('input[type="hidden"][name="properties[Brand]"]');

    if (brandHidden) {
      if (checked) brandHidden.value = checked.value || "";
    }

    root.querySelectorAll(".exp-brand-tile").forEach((el) => el.classList.remove("is-active"));
    const label = checked?.closest(".exp-brand-tile");
    if (label) label.classList.add("is-active");
  }

  function syncSingleBrand(root) {
    const tile = root.querySelector(".exp-brand--static");
    if (!tile) return;

    const name = tile.getAttribute("data-single-brand-name") || "";
    const brandHidden = root.querySelector('input[type="hidden"][name="properties[Brand]"]');
    if (brandHidden) brandHidden.value = name;
  }

  function ensureDefaultBrandIfNeeded(root) {
    const bc = brandCount(root);
    if (bc < 2) return;
    if (getMethod(root) !== "Sender's Choice") return;

    const checked = root.querySelector('input[type="radio"][name="properties[Brand]"]:checked');
    if (checked) return;

    const first = root.querySelector('input[type="radio"][name="properties[Brand]"]');
    if (first) {
      first.checked = true;
      first.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function clearBrandSelection(root) {
    root
      .querySelectorAll('input[type="radio"][name="properties[Brand]"]')
      .forEach((r) => (r.checked = false));

    root.querySelectorAll(".exp-brand-tile").forEach((el) => el.classList.remove("is-active"));

    const brandHidden = root.querySelector('input[type="hidden"][name="properties[Brand]"]');
    if (brandHidden) brandHidden.value = "";
  }

  function syncBrandOptionsProperty(root) {
    const optionsHidden = root.querySelector(
      'input[type="hidden"][name="properties[Brand Options]"]'
    );
    if (!optionsHidden) return;

    const bc = brandCount(root);
    const method = getMethod(root);
    const csv = getBrandOptionsCSV(root);

    if (bc >= 2 && method === "Recipient's Choice") {
      optionsHidden.value = csv || "";
    } else {
      optionsHidden.value = "";
    }
  }

  function validateRequired(root) {
    const err = root.querySelector(".exp-gift__form-error");
    if (err) {
      err.textContent = "";
      err.setAttribute("hidden", "");
    }

    const name = root.querySelector('input[name="properties[Recipient Name]"]');
    const email = root.querySelector('input[name="properties[Recipient Email]"]');

    const missingName = !name || !name.value.trim();
    const missingEmail = !email || !email.value.trim();

    if (missingName || missingEmail) {
      if (err) {
        err.textContent = "Please enter the recipient name and email.";
        err.removeAttribute("hidden");
      }
      return false;
    }

    return true;
  }

  function validateBrand(root) {
    const brandErr = root.querySelector(".exp-gift__brand-error");
    if (brandErr) {
      brandErr.textContent = "";
      brandErr.setAttribute("hidden", "");
    }

    const bc = brandCount(root);
    if (bc < 2) return true;

    if (getMethod(root) === "Sender's Choice") {
      ensureDefaultBrandIfNeeded(root);
      const selected = root.querySelector('input[type="radio"][name="properties[Brand]"]:checked');
      if (!selected) {
        if (brandErr) {
          brandErr.textContent =
            "Please choose an option (Sender’s Choice requires a specific brand).";
          brandErr.removeAttribute("hidden");
        }
        return false;
      }
    }

    return true;
  }

  function applyMode(root) {
    const bc = brandCount(root);
    const mode = bc >= 2 && getMethod(root) === "Recipient's Choice" ? "recipient" : "sender";

    root.classList.toggle("is-sender-mode", mode === "sender");
    root.classList.toggle("is-recipient-mode", mode === "recipient");

    setHidden(root.querySelector(".exp-help--recipient"), mode !== "recipient");
    setHidden(root.querySelector(".exp-help--sender"), mode !== "sender");
    setHidden(root.querySelector(".exp-brand-instructions--recipient"), mode !== "recipient");
    setHidden(root.querySelector(".exp-brand-instructions--sender"), mode !== "sender");

    if (bc === 1) {
      syncSingleBrand(root);
    }

    if (mode === "recipient" && bc >= 2) {
      clearBrandSelection(root);
    } else {
      ensureDefaultBrandIfNeeded(root);
      syncBrandHiddenAndActive(root);
    }

    syncBrandOptionsProperty(root);
  }

  function setButtonState(root) {
    const form = getForm(root);
    const btn = getSubmitButton(form);
    if (!btn) return;

    const ok = validateRequired(root);
    btn.toggleAttribute("disabled", !ok);
    btn.classList.toggle("is-disabled", !ok);
  }

  function initRoot(root) {
    // Prevent double init per node instance
    if (root.dataset.expInit === "1") return;
    root.dataset.expInit = "1";

    applyMode(root);
    syncBrandHiddenAndActive(root);
    setButtonState(root);
  }

  function initAll(scope = document) {
    scope.querySelectorAll(".exp-gift").forEach(initRoot);
  }

  function getGiftRootsForForm(form) {
    const roots = [];

    const inside = form?.querySelectorAll?.(".exp-gift") || [];
    inside.forEach((r) => roots.push(r));

    const formId = form?.id;
    if (formId) {
      document
        .querySelectorAll(`.exp-gift[data-product-form-id="${CSS.escape(formId)}"]`)
        .forEach((r) => {
          if (!roots.includes(r)) roots.push(r);
        });
    }

    return roots;
  }

  // ---------------------------
  // Event handlers
  // ---------------------------

  document.addEventListener("click", (e) => {
    const pill = e.target.closest?.(".exp-pill");
    if (!pill) return;

    const root = closestGiftRoot(pill);
    if (!root) return;

    const radio = pill.querySelector('input[type="radio"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    }

    applyMode(root);
    setButtonState(root);
  });

  document.addEventListener("change", (e) => {
    const root = closestGiftRoot(e.target);

    // Variant/value changed (Dawn updates the variant id input)
    if (e.target.matches?.('form[action*="/cart/add"] input[name="id"]')) {
      setTimeout(() => {
        document.querySelectorAll(".exp-gift").forEach((r) => setButtonState(r));
      }, 0);
      return;
    }

    if (!root) return;

    if (e.target.matches?.('input[type="radio"][name="properties[Redemption Method]"]')) {
      applyMode(root);
      setButtonState(root);
      return;
    }

    if (e.target.matches?.('input[type="radio"][name="properties[Brand]"]')) {
      if (getMethod(root) === "Recipient's Choice") {
        clearBrandSelection(root);
      } else {
        syncBrandHiddenAndActive(root);
      }
      syncBrandOptionsProperty(root);
      setButtonState(root);
      return;
    }

    if (
      e.target.matches?.(
        'input[name="properties[Recipient Name]"], input[name="properties[Recipient Email]"]'
      )
    ) {
      setButtonState(root);
      return;
    }
  });

  document.addEventListener("input", (e) => {
    const root = closestGiftRoot(e.target);
    if (!root) return;

    if (
      e.target.matches?.(
        'input[name="properties[Recipient Name]"], input[name="properties[Recipient Email]"]'
      )
    ) {
      setButtonState(root);
    }
  });

  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!form || form.tagName.toLowerCase() !== "form") return;

      const roots = getGiftRootsForForm(form);
      if (!roots.length) return;

      let okAll = true;

      roots.forEach((root) => {
        applyMode(root);

        const ok1 = validateRequired(root);
        const ok2 = validateBrand(root);

        setButtonState(root);

        if (!(ok1 && ok2)) okAll = false;
      });

      if (!okAll) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  // ---------------------------
  // ✅ Dawn filters compatibility
  // ---------------------------

  let gridObserver = null;
  let bodyObserver = null;
  let lastObservedGrid = null;

  function debounce(fn, wait = 50) {
    let t = null;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  const reinitDebounced = debounce(() => initAll(document), 60);

  function attachGridObserver() {
    const gridContainer = document.querySelector("#ProductGridContainer");
    const productGrid = document.querySelector("#product-grid");

    const target = productGrid || gridContainer;
    if (!target) return;

    // If Dawn replaced the grid nodes, reattach
    if (target === lastObservedGrid && gridObserver) return;

    if (gridObserver) {
      gridObserver.disconnect();
      gridObserver = null;
    }

    lastObservedGrid = target;

    gridObserver = new MutationObserver((mutations) => {
      // Any grid update could include new exp-gift nodes
      for (const m of mutations) {
        if (m.type === "childList" && (m.addedNodes?.length || m.removedNodes?.length)) {
          reinitDebounced();
          break;
        }
      }
    });

    gridObserver.observe(target, { childList: true, subtree: true });
  }

  function attachBodyObserver() {
    if (bodyObserver) return;

    bodyObserver = new MutationObserver(() => {
      // If Dawn swapped/rebuilt the grid container, we need to reattach observers
      attachGridObserver();
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initAll(document);
    attachGridObserver();
    attachBodyObserver();
  });

  document.addEventListener("shopify:section:load", (evt) => {
    initAll(evt.target);
    attachGridObserver();
  });
})();